import { fetchAuthSession } from "@aws-amplify/auth";

export interface AuthHeaders {
    Authorization: string;
}

export const getAuthHeaders = async (): Promise<AuthHeaders> => {
    const session = await fetchAuthSession();
    const idToken = session?.tokens?.idToken?.toString();
    if (!idToken) {
        throw new Error("No authentication token available");
    }
    return { Authorization: `Bearer ${idToken}` };
};
